<div class="row">
    <div class="col-sm-9">
        <h2>Terms and conditions</h2>
    </div>
    <div class="col-sm-3" [formGroup]="termsAndConditionForm">
        <ng-select [items]="selectedLanguage" [searchable]="true" bindLabel="lable" bindValue="value" required
            formControlName="language" (change)="getTermsAndconditions()" [clearable]="false"></ng-select>
    </div>
</div>
<nb-card>
    <nb-card-body style="position: relative">
        <div class="col-sm-12" [formGroup]="termsAndConditionForm">
            <angular-editor [placeholder]="'Enter text here...'" class="editor-container" formControlName="content"
                required></angular-editor>
        </div>
        <div *ngIf="termsAndConditionForm.get('content').hasError('required') && (termsAndConditionForm.get('content').touched || isSubmittedLocationForm)" class="text-danger">
            Content is required.
        </div>
    </nb-card-body>
</nb-card>

<button type="submit" style="float: right" class="btn btn-primary px-4" (click)="onEnter()">
    save
</button>